export default function readibleAbnString(n) {
  if (n)
    return `${n?.substring(0, 3)} ${n?.substring(3, 6)} ${n?.substring(
      6,
      9
    )} ${n?.substring(9, 12)}`;
}
